import { Component, OnDestroy, OnInit } from '@angular/core';
import { Actions, ofActionDispatched, Store } from '@ngxs/store';
import { Subscription } from 'rxjs';
import { SnackNotifier } from '@app/shared/notifier/snack-notifier';
import { Navigate } from '@ngxs/router-plugin';
import { AuthActions } from '@app/modules/auth/store/auth.actions';
import { IRegistration } from '@app/modules/auth/interface/registration';
import { UserModel } from '@app/modules/user/model/user';
import { UserState } from '@app/modules/user/store/user.state';

@Component({ templateUrl: './registration.component.html' })
export class RegistrationPageComponent implements OnInit, OnDestroy {
  public get user(): UserModel {
    return this.store.selectSnapshot(UserState.model);
  }

  private _subscription = new Subscription();
  private isRegistering = false;

  /**
   * @param store
   * @param actions
   * @param snack
   */
  constructor(
    private readonly store: Store,
    private readonly actions: Actions,
    private readonly snack: SnackNotifier,
  ) {}

  public ngOnInit(): void {
    // user is null before any role selection — same crash class as the
    // share page (unguarded read kills init).
    if (!this.user?.role) {
      this.store.dispatch(new Navigate(['/auth/select-role']));
    }
    this.subscribeOnRegistrationSuccess();
    this.subscribeOnRegistrationFailed();
  }

  public ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }

  public registration(value: IRegistration): void {
    if (this.isRegistering) {
      return;
    }

    this.isRegistering = true;
    this.store.dispatch(new AuthActions.Registration({
      email: value.email,
      password: value.password,
      role: this.user.role,
      pin: value.pin
    }));
  }

  private subscribeOnRegistrationSuccess(): void {
    this._subscription.add(
      this.actions
        .pipe(ofActionDispatched(AuthActions.RegistrationSuccess))
        .subscribe(() => {
          this.isRegistering = false;
          this.store.dispatch(new Navigate(['/auth/login']));
        })
    );
  }

  private subscribeOnRegistrationFailed(): void {
    this._subscription.add(
      this.actions
        .pipe(ofActionDispatched(AuthActions.RegistrationFailed))
        .subscribe(({ error }) => {
          this.isRegistering = false;
          this.snack.error(error)
        }),
    );
  }
}
